export enum UserType {
    Pilot = "Pilot",
    Observer = "Observer",
}